import { styled } from '@mui/material';

import { useSearchParams } from 'react-router';

import { useEffect } from 'react';

// import { MessageBus } from '@app-velocity/message-bus';

import { PrototypeDecision } from './components/PrototypeDecision';
import { Confusions } from './components/Confusions';
import { TestParticipants } from './components/TestParticipants';
import { UsabilityResults } from './components/UsabilityResults';
import { Details } from './components/Details';

const MainGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  width: '100%',
  gap: theme.spacing(4),
  gridTemplateColumns: '1fr',
  gridTemplateAreas: `
  "verdict"
  "results"
  "confusions"
  "details"
  "metrics"
  "sugestions"`,
  '@media screen and (min-width: 1024px)': {
    gridTemplateColumns: '1fr 1fr',
    gridTemplateAreas: `
  "verdict verdict"
  "details details"
  "metrics results"
  "confusions confusions"
  "suggestions suggestions"`,
  },
  '@media screen and (min-width: 1368px)': {
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateAreas: `
  "verdict results confusions"
  "metrics details confusions"
  "suggestions suggestions confusions"`,
  },
}));

const SingleArea = styled('div')<{ area: string }>(({ area }) => ({
  gridArea: area,
}));

// const messageBus = new MessageBus('prototypes');

export const Overview = () => {
  const [params, setParams] = useSearchParams();
  const action = params.get('action');

  useEffect(() => {
    if (!action) return;

    // switch (action) {
    //   case 'target-metrics': {
    //     messageBus.publish('modal:report-config:open', {
    //       workspaceId: scenario.projectId || '',
    //       scenarioId: scenario.id || '',
    //     });
    //     break;
    //   }
    // }

    setParams('');
  }, [action]);

  return (
    <MainGrid>
      <SingleArea area="verdict">
        <PrototypeDecision />
      </SingleArea>
      <SingleArea area="results">
        <TestParticipants />
      </SingleArea>
      <SingleArea area="confusions">
        <Confusions />
      </SingleArea>
      <SingleArea area="details">
        <Details />
      </SingleArea>
      <SingleArea area="metrics">
        <UsabilityResults />
      </SingleArea>
    </MainGrid>
  );
};
